var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScissor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72909 10.4167C7.74262 10.4167 9.37492 8.78437 9.37492 6.77083C9.37492 4.7573 7.74262 3.125 5.72909 3.125C3.71555 3.125 2.08325 4.7573 2.08325 6.77083C2.08325 8.78437 3.71555 10.4167 5.72909 10.4167Z",
    fill: "#2E37A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72909 21.8776C7.74262 21.8776 9.37492 20.2453 9.37492 18.2318C9.37492 16.2182 7.74262 14.5859 5.72909 14.5859C3.71555 14.5859 2.08325 16.2182 2.08325 18.2318C2.08325 20.2453 3.71555 21.8776 5.72909 21.8776Z",
    fill: "#2E37A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.8858 12.4795L23.3858 6.87528C23.7295 6.61487 23.8024 6.12528 23.542 5.78153C23.2816 5.43778 22.792 5.36487 22.4483 5.62528L14.5837 11.5107L8.80245 7.18778C8.4587 6.92737 7.9691 7.00028 7.70868 7.34403C7.44827 7.68778 7.52118 8.17737 7.86493 8.43778L13.2816 12.4899L7.13578 17.094C6.79203 17.3545 6.71912 17.844 6.97953 18.1878C7.13578 18.3961 7.36493 18.5003 7.60451 18.5003C7.77118 18.5003 7.92744 18.4482 8.07327 18.344L14.5941 13.469L22.4587 19.3545C22.5941 19.4586 22.7608 19.5107 22.9275 19.5107C23.167 19.5107 23.3962 19.4065 23.5524 19.1982C23.8128 18.8545 23.7399 18.3649 23.3962 18.1044L15.8858 12.4795Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissor);
export default __webpack_public_path__ + "static/media/scissor.4e8750f46347637caca13b33a6ffdc86.svg";
export { ForwardRef as ReactComponent };